module.exports = __webpack_public_path__ + "static/media/cert-badge.bff9af1d.svg";